import { Grid, type GridOwnProps, styled } from '@mui/material'

const CartListGrid = styled<typeof Grid>((props: GridOwnProps) => (
  <Grid item xs={12} md={8} lg={9} {...props} />
))({})

export default CartListGrid
